import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Search, Filter, Download, ShieldCheck } from 'lucide-react';
import { Button } from '../../components/ui/Button';
// Mock Audit Data
const mockAuditLogs = [{
  id: 'LOG-001',
  timestamp: '2025-02-14 10:30:45',
  actor: 'Andi Pratama (Admin)',
  action: 'CREATE_CAMPAIGN',
  target: 'Kampanye HPSN 2025',
  details: 'Created new campaign with 3 assets',
  ip: '192.168.1.10'
}, {
  id: 'LOG-002',
  timestamp: '2025-02-14 11:15:20',
  actor: 'Budi Santoso (Officer)',
  action: 'SUBMIT_EVIDENCE',
  target: 'Assignment #4521',
  details: 'Submitted Instagram URL',
  ip: '182.253.12.4'
}, {
  id: 'LOG-003',
  timestamp: '2025-02-14 11:20:10',
  actor: 'Siti Aminah (Validator)',
  action: 'VALIDATE_EVIDENCE',
  target: 'Assignment #4521',
  details: 'Approved evidence submission',
  ip: '192.168.1.15'
}, {
  id: 'LOG-004',
  timestamp: '2025-02-14 13:45:00',
  actor: 'System',
  action: 'UPDATE_SCORE',
  target: 'Kota Surabaya',
  details: 'Recalculated score: 95',
  ip: '127.0.0.1'
}, {
  id: 'LOG-005',
  timestamp: '2025-02-14 14:00:00',
  actor: 'Andi Pratama (Admin)',
  action: 'UPDATE_RULES',
  target: 'Scoring Config',
  details: 'Changed on-time bonus from 15 to 20',
  ip: '192.168.1.10'
}];
export function AuditLogPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const columns = [{
    header: 'Timestamp',
    cell: (row: any) => <div className="text-sm text-gray-600 font-mono" data-id="element-723">{row.timestamp}</div>
  }, {
    header: 'Actor',
    cell: (row: any) => <div className="font-medium text-gray-900" data-id="element-724">{row.actor}</div>
  }, {
    header: 'Action',
    cell: (row: any) => <StatusBadge status="neutral" className="font-mono text-xs" data-id="element-725">
          {row.action}
        </StatusBadge>
  }, {
    header: 'Target & Details',
    cell: (row: any) => <div data-id="element-726">
          <div className="font-medium text-gray-900 text-sm" data-id="element-727">{row.target}</div>
          <div className="text-xs text-gray-500" data-id="element-728">{row.details}</div>
        </div>
  }, {
    header: 'IP Address',
    cell: (row: any) => <div className="text-xs text-gray-400 font-mono" data-id="element-729">{row.ip}</div>
  }];
  return <CommandCenterLayout title="Audit Logs" subtitle="Rekam jejak aktivitas sistem untuk keamanan dan akuntabilitas" data-id="element-730">
      <Card data-id="element-731">
        <CardHeader className="flex flex-row items-center justify-between" data-id="element-732">
          <div className="flex items-center gap-2" data-id="element-733">
            <ShieldCheck className="h-5 w-5 text-primary-600" data-id="element-734" />
            <CardTitle data-id="element-735">System Activity Log</CardTitle>
          </div>
          <Button variant="outline" className="gap-2" data-id="element-736">
            <Download className="h-4 w-4" data-id="element-737" /> Export CSV
          </Button>
        </CardHeader>
        <CardContent data-id="element-738">
          <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-739">
            <div className="relative flex-1" data-id="element-740">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-741" />
              <Input placeholder="Cari log (actor, action, details)..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-742" />
            </div>
            <div className="flex gap-2" data-id="element-743">
              <Select data-id="element-744">
                <option data-id="element-745">Semua Action</option>
                <option data-id="element-746">CREATE</option>
                <option data-id="element-747">UPDATE</option>
                <option data-id="element-748">DELETE</option>
                <option data-id="element-749">VALIDATE</option>
              </Select>
              <Input type="date" className="w-auto" data-id="element-750" />
            </div>
          </div>

          <DataTable data={mockAuditLogs} columns={columns} keyExtractor={item => item.id} data-id="element-751" />
        </CardContent>
      </Card>
    </CommandCenterLayout>;
}